import React, { useMemo } from "react";
import { Ptag } from "components/core";
import GradeAttributeDetail from "./GradeAttributeDetail";
import { GradeAttributesWrapper } from "./styles";
import useUser from "hooks/useUser";

const ATTRIBUTES_FOR_HR = [
  "Maternity Coverage",
  "Room Rent Limit",
  "Disease Wise Sub limit",
];

function GradeAttributes({ attributes }) {
  const { getRole } = useUser();
  const role = getRole();
  const validAttributes = useMemo(() => {
    if (role === "admin") return attributes;
    return attributes.filter(({ name }) => ATTRIBUTES_FOR_HR.includes(name));
  }, []);
  if (!attributes || !attributes.length) return null;

  function filterAttributesWithoutRoomRentPercentage(attributes) {
    return attributes.filter(attr => {
      // If it's NOT "Room Rent Limit" AND NOT "Maternity Coverage", return as-is
      if (attr.name !== "Room Rent Limit" && attr.name !== "Maternity Coverage") {
        return true;
      }

      const values = attr?.data?.values;

      const isValidString = (val) =>
        typeof val === "string" && val.trim() !== "";

      const hasAnyValue =
        isValidString(values?.normal?.percentage) ||
        isValidString(values?.normal?.max) ||
        isValidString(values?.icu?.percentage) ||
        isValidString(values?.icu?.max);

      return hasAnyValue;
    });
  }
  
  

  // const updatedAttributes = filterAttributesWithoutRoomRentPercentage(attributes);

  // const filteredAttributes = updatedAttributes?.filter(attribute => {
  const filteredAttributes = attributes?.filter(attribute => {
    const values = attribute?.data?.values;
    if (!values) return false;
    
    const hasMeaningfulValues = Object.values(values).some(value => {
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(nestedValue => 
          nestedValue !== null && nestedValue !== undefined && nestedValue !== "" && nestedValue !== 0
        );
      }
      return value !== null && value !== undefined && value !== "" && value !== 0;
    });
    
    return hasMeaningfulValues;
  });

  if (!filteredAttributes || filteredAttributes.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: "64px" }}>
      {/* <header>
        <Ptag
          color="#422B7B"
          fontWeight="600"
          fontSize="24px"
          marginTop="64px"
          marginBottom="24px"
        >
          What is Covered?
        </Ptag>
      </header> */}
      <GradeAttributesWrapper>
        {filteredAttributes?.map((attribute) => (
          <GradeAttributeDetail key={attribute?.name} attribute={attribute} />
        ))}
      </GradeAttributesWrapper>
    </div>
  );
}

export default GradeAttributes;
